<template>
    <div class="first-init-msg">
        <div class="inner">
            <div class="content" v-if="isQualifiedInitUser">
                <h3 class="title">歡迎您，讓我們開始啟用設定吧</h3>
                <div class="description">
                    <p>這是您的第一次使用，啟用前需要先設定些必要設定。</p>
                    <p>（ 公司資訊、銀行帳戶、收支項目、審核流程設定 ）</p>
                </div>
                <el-button type="" @click="$router.push({ name: 'setup-start' })" id="index-init-start-btn">開始啟用設定</el-button>
            </div>
            <div class="content" v-else>
                <h3 class="title">尚未完成系統啟用</h3>
                <div class="description">
                    <p>貴公司尚未完成系統啟用設定，敬請等待管理員完成設定。</p>
                    <p></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'first-init-msg',
    data() {
        return {};
    },
    computed: {
        isQualifiedInitUser() {
            return (
                this.isAuth('F03') // 銀行帳戶設定
                && this.isAuth('F05') // 收支項目設定
                && this.isAuth('F22') // 審核流程設定
                && this.isAuth('F23') // 公司資訊設定
                && this.isAuth('E02') // 零用現金管理
            );
        },
    },
    methods: {},
};
</script>
<style lang="scss">
@import "@/assets/scss/vars.scss";

.first-init-msg {
    position: fixed;
    display: table;
    top: 40px;
    left: 0;
    width: 100%;
    height: 100%;
    color: #fff;
    background-color: $main-color;
    padding: 30px;
    text-align: center;
    z-index: 9999;
    line-height: 150%;

    .inner {
        display: table-cell;
        vertical-align: middle;

        .content {
            max-width: 500px;
            margin: 0 auto;
        }
    }

    .title {
        font-size: 23pt;
        margin-bottom: 30px;
    }

    .description {
        margin: 20px auto;
        max-width: 500px;
        font-size: 12pt;
        margin-bottom: 50px;
    }

    .el-button {
        color: $main-color;
        font-weight: bold;
        font-size: 11pt;
    }
}
</style>
